<div class="edit-clinical-study">
  <div class="container-fluid">
    <div
      class="bg-white p-2 study-shell"
      *ngIf="(activeSaleHorseStudy$ | async)?.saleId > 0"
    >
      <!-- Back Button Start -->
      <div class="row" *ngIf="!sale_id">
        <div class="col-md-12 mb-2">
          <a
            href="javascript:history.back()"
            class="cursor-pointer text-decoration-none text-dark"
          >
            <button
              type="button"
              class="btn btn-outline-success btn-square me-2"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <span class="text">Back</span>
          </a>
        </div>
      </div>
      <!-- Back Button End -->
      <!-- Breadcrumb Start -->
      <div class="row" *ngIf="!sale_id">
        <div class="col-md-12">
          <div class="breadcrumb-wrap ms-0 mt-1">
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active">
                  <a routerLink="/sales" class="cursor-pointer">All Sales</a>
                </li>
                <li aria-current="page" class="breadcrumb-item active">
                  <i class="fas fa-chevron-right me-2"></i> {{ sale?.saleName }}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
      <!-- Breadcrumb End -->
      <!-- Top Details Section Start -->
      <!--
        Compact single-band header. Same fields as before, laid out on one line
        instead of two stacked half-width columns, so the file lists below start
        near the top of the modal rather than half way down it.
      -->
      <div class="study-head" *ngIf="isSaleFeatureEnabled">
        <div class="study-head__sale">
          <div class="study-head__thumb">
            <img
              [src]="sale?.saleImageUrl"
              *ngIf="sale?.saleImageUrl; else placeholder"
              alt=""
            />

            <ng-template #placeholder>
              <img
                src="assets/images/horse-no-img.jpg"
                class="default-img"
                alt=""
              />
            </ng-template>
          </div>
          <div class="study-head__sale-text">
            <span class="study-head__location">{{ sale?.location }}</span>
            <span class="study-head__sale-name" [title]="sale?.saleName">{{ sale?.saleName }}</span>
            <span class="study-head__date">{{
              sale?.startDate | date : "dd MMM yyyy"
            }}</span>
          </div>
        </div>

        <div class="study-head__horse">
          <div class="study-head__lot">
            <span class="study-head__lot-label">{{ lotOrHipText }}</span>
            <span class="study-head__lot-number">{{ horse?.lot }}</span>
          </div>
          <!--
            Ordered to read down the columns, not across: the grid fills
            row-wise, so pairing Horse/DOB, Sire/Type, Dam/Consignor puts
            pedigree in the left column and the sale facts in the right.
          -->
          <dl class="study-head__meta">
            <div class="study-head__meta-item">
              <dt>Horse</dt>
              <dd [title]="horse?.name">{{ horse?.name }}</dd>
            </div>
            <div class="study-head__meta-item">
              <dt>DOB</dt>
              <dd>{{ horse?.dob | date : getDateFormation() }}</dd>
            </div>
            <div class="study-head__meta-item">
              <dt>Sire</dt>
              <dd [title]="horse?.sireDisplay">{{ horse?.sireDisplay }}</dd>
            </div>
            <div class="study-head__meta-item">
              <dt>Type</dt>
              <dd>{{ horse?.horseAgeCategoryName }}</dd>
            </div>
            <div class="study-head__meta-item">
              <dt>Dam</dt>
              <dd [title]="horse?.dam">{{ horse?.dam }}</dd>
            </div>
            <div class="study-head__meta-item">
              <dt>Consignor</dt>
              <dd [title]="horse?.consignorName">{{ horse?.consignorName }}</dd>
            </div>
          </dl>
        </div>
      </div>
      <!-- Top Details Section End -->
      <div class="flex study-head__toggle-wrap">
        <a
          href="horseDetails"
          class="no-underline text-dark study-head__toggle"
          onclick="return false;"
          (click)="toggleTable()"
        >
          <i
            class="fa {{ showTable ? 'fa-caret-down' : 'fa-caret-right' }}"
          ></i>
          Horse Details
        </a>
      </div>

      <div
        class="review-submission-section mt-2 detail-table"
        [class.hide-table]="!showTable"
      >
        <div class="row">
          <div class="col-md-12">
            <div class="table-scroll table-responsive data-grid bg-gray pb-0">
              <table mat-table [dataSource]="dataSource" class="table">
                <ng-container matColumnDef="entry">
                  <th mat-header-cell *matHeaderCellDef class="w-0-2-rem"></th>
                  <td mat-cell *matCellDef="let element" class="w-0-2-rem">
                    {{ element.type }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="accNo">
                  <th mat-header-cell *matHeaderCellDef class="w-3-rem">
                    ACC.#
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.accessionCode }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="saleName">
                  <th mat-header-cell *matHeaderCellDef class="w-5-rem">
                    Sale Name
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="less-height-2-rem"
                  >
                    {{ element.horse.saleName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="type">
                  <th mat-header-cell *matHeaderCellDef class="w-2-rem">
                    Type
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.horseAgeCategoryName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="hip">
                  <th mat-header-cell *matHeaderCellDef class="w-1-rem">
                    {{ lotOrHipText }}
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.lot }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="horseName">
                  <th mat-header-cell *matHeaderCellDef class="w-5-rem">
                    Horse Name
                  </th>
                  <td
                    mat-cell
                    *matCellDef="let element"
                    class="less-height-2-rem"
                  >
                    {{ element.horse.name }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="sire">
                  <th mat-header-cell *matHeaderCellDef class="w-2-rem">
                    Sire
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.sireDisplay }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="dam">
                  <th mat-header-cell *matHeaderCellDef class="w-1-rem">Dam</th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.dam }}
                  </td>
                </ng-container>

                <!--<ng-container matColumnDef="dob">
                <th mat-header-cell *matHeaderCellDef>DOB</th>
                <td mat-cell *matCellDef="let element">
                  Don't have this field
                </td>
              </ng-container>-->

                <ng-container matColumnDef="microchip">
                  <th mat-header-cell *matHeaderCellDef class="w-1-rem">
                    ID/Microchip #:
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{
                      element.horse.microchip ||
                        element.microchipNumber ||
                        "N/A"
                    }}
                  </td>
                </ng-container>

                <ng-container matColumnDef="consignor">
                  <th mat-header-cell *matHeaderCellDef class="w-2-rem">
                    Consignor
                  </th>
                  <td mat-cell *matCellDef="let element">
                    {{ element.horse.consignorName }}
                  </td>
                </ng-container>
                <ng-container matColumnDef="studyDate">
                  <th mat-header-cell *matHeaderCellDef class="w-2-rem">
                    Study Date
                  </th>
                  <td mat-cell *matCellDef="let element">
                    <span *ngIf="element.type == 'Repo'">
                      {{ element.horse.studyDate }}
                    </span>
                    <span
                      *ngIf="
                        element.isAfterAllowedSubmissionDate &&
                        element.type != 'Repo'
                      "
                      class="text text-success"
                    >
                      {{ element.horse.studyDate }}
                    </span>
                    <span
                      *ngIf="
                        !element.isAfterAllowedSubmissionDate &&
                        element.type != 'Repo'
                      "
                      class="text text-danger"
                    >
                      {{ element.horse.studyDate }}
                    </span>
                  </td>
                </ng-container>

                <!--<ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>Actions</th>
                <td mat-cell *matCellDef="let element">
                  <div class="flex align-items-center">-->
                <!-- <a
                      href="https://test-viewer.thoroughworks.com/viewer/{{
                        element.studyInstanceUID
                      }}"
                      target="_blank"
                      class="btn btn-success m-1"
                    >
                      <i class="fas fa-external-link-alt"></i>
                    </a> -->
                <!--<div class="btn btn-success m-1" (click)="viewStudy(element.studyInstanceUID, element.horse.name)">
                      <i class="fas fa-external-link-alt"></i>
                    </div>
                  </div>
                </td>
              </ng-container>-->

                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr
                  mat-row
                  *matRowDef="let row; columns: displayedColumns"
                  class="border-start-0 border-end-0 pt-2"
                ></tr>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="review-submission-section mt-2">
        <div class="row" *ngIf="!(tabStatus$ | async)?.landOnApprovedTab">
          <div class="col-md-12 text-center">
            <button
              *ngIf="!hipConfirmed"
              (click)="confirmHip()"
              class="btn btn-primary"
            >
              Confirm Correct {{ lotOrHipText }} to Proceed Below
            </button>
          </div>
        </div>
        <ng-container
          *ngIf="hipConfirmed || (tabStatus$ | async)?.landOnApprovedTab"
        >
          <app-edit-study
            [saleId]="saleId"
            [horseId]="horseId"
            [studyId]="studyId"
            [saleName]="sale?.saleName"
            [horseName]="horse?.horseName"
            [lot]="horse?.lot"
            [lotOrHipText]="lotOrHipText"
            [tabStatus]="tabStatus"
            [catalogDataSource]="dataSource"
            (closedClicked)="closeModal()"
            (onChangeTab)="onChangeTab($event)"                
          ></app-edit-study>
        </ng-container>
      </div>
    </div>
  </div>
</div>
